import { render, staticRenderFns } from "./EtcReturnChangePop.vue?vue&type=template&id=2ab2ce2a"
import script from "./EtcReturnChangePop.vue?vue&type=script&lang=js"
export * from "./EtcReturnChangePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab2ce2a')) {
      api.createRecord('2ab2ce2a', component.options)
    } else {
      api.reload('2ab2ce2a', component.options)
    }
    module.hot.accept("./EtcReturnChangePop.vue?vue&type=template&id=2ab2ce2a", function () {
      api.rerender('2ab2ce2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/EtcReturnChangePop.vue"
export default component.exports